<template>
  <div class="video-post" v-if="itemReady">
    <div class="video" v-if="activeVideo">
      <video-player
        class="vjs-custom-skin"
        ref="videoPlayer"
        :options="playerOptions"
        @ready="playerReadied"
      ></video-player>
    </div>
    <div
      class="video touchpad video_special"
      :style="{'background-image': 'url('+miconfig.thumb+'),url('+miconfig.noticiero.imagen+'),url('+defaultImage+')'}"
      @click="playVideo"
      v-else
    >
      <button class="video-button secondary touchpad">
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-play"
          >
            <polygon points="5 3 19 12 5 21 5 3" />
          </svg>
        </span>
      </button>
    </div>
    <div
      class="info-video  noPadding"
      style="background:#fff;height:90px; "
    >
      <div class="info-video">
        <div class="tvIcon" v-if="mtype == 't'">
          <img v-if="config.new" src="/assets/img/tele.png" alt="Icon" class="icon" width="23px" height="21px" >
          <svg
            v-else
            data-v-17c699d4
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="30px"
            height="30px"
            viewBox="0 0 24 24"
          >
            <path
              data-v-17c699d4
              d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z"
            />
          </svg>
        </div>
        <div class="tvIcon" v-if="mtype == 'r'">
          <img v-if="config.new" src="/assets/img/radio-n.png" alt="Icon" class="icon" width="23px" height="21px" >
          <svg
            v-else
            data-v-17c699d4
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            aria-hidden="true"
            focusable="false"
            width="30px"
            height="30px"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
          >
            <path
              data-v-17c699d4
              d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8z"
            />
          </svg>
        </div>
       
        <span class="video-type   noBackground noPadding noMargin">
          {{miconfig.noticiero.nombre.length>12? miconfig.noticiero.nombre.slice(0,12)+'...':miconfig.noticiero.nombre}}
        </span>
        <h4 :class="{'video-title hora-r blink': config.new ,'video-title': !config.new }" v-html="convertStringAndTrim(miconfig.titulo)"></h4>
      </div>
    </div>
   
    <div class="video-post-footer">
      <div class="textPanel-footer">
        <div class="row no-gutters">
          <div class="col-10">
            
            <span class v-if="miconfig.publicado_utc">{{parseFecha(miconfig.publicado_utc)}}
            </span>
          </div>
          <div class="col-2 button small noMargin noPadding noBackground linkArrow tooltip tooltip-top" data-tooltip="Ver más">
            <font-awesome-icon icon="arrow-right" @click="goToNote" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import moment from "moment-timezone";
import { strings } from "@/services/strings.js";
import 'videojs-contrib-hls';

export default {
  name: "mvideo",
  props: ["config", "emptyItem","from","index"],
  mixins: [strings],
  data() {
    return {
      url: this.$store.getters.getMainUrl,
      fecha: "",
      item: {},
      itemReady: false,
      miconfig: {},
      playerOptions: {
        // videojs and plugin options
        height: "100%",
        sources: [
          {
            withCredentials: false,
            type: "application/x-mpegURL",
            src: "" // "https://d8.bdtr.net/hls/notas.m3u8?c=DF_MEX-T4-20190308-2917-50718-179" //  this.playerOptions.sources[0].src = this.streams.hls
          }
        ],
        controlBar: {
          timeDivider: false,
          durationDisplay: true
        },
        flash: { hls: { withCredentials: false } },
        html5: {
          vhs: { withCredentials: false, overrideNative: true },
          hls: { withCredentials: false, overrideNative: true },
          nativeAudioTracks: false,
          nativeVideoTracks: false
        },
        poster: this.$store.state.defaultNote,
        autoplay: true,
        responsive: true
      },
      activeVideo: false,
      defaultImage: this.$store.state.defaultTV,
      mtype: ""
    };
  },
  computed:{
    token(){
      return this.$store.getters.getToken;
    }
  },
  beforeMount() {
    if(this.from == "public"){
      this.setConfig();
    }else{
      this.getItem();
    }
  },
  methods: {
    getPublicItem(){
      var params = {
        table:'t_notas',
        key:this.config.key,
        ipid: this.$store.state.publicUser.ipid
      };
      var self = this;
      
      var encrypted = this.$CryptoJS.AES.encrypt(JSON.stringify(params),'secret 1576508387911');
  
      axios
        .post(this.url + "getPublicNote", JSON.stringify({params:encodeURIComponent(encrypted)})) //petición
        .then(response => {
          if (response.data.success) {
            self.mtype = response.data.data.medioTipo;
            response.data.data["media"] = response.data.data.claveorigen;
            self.setConfig(response.data.data);
          }
        })
        .catch(function(error) {
          var response = { success: false, error: error };
          console.log(error);
        });
    },
    getItem() {
      var post_data = {
        token: this.token,
        key: this.config.noteKey ? this.config.noteKey : this.config.key,
        entrada: this.config.entrada
      };
      var self = this;
      axios
        .post(this.url + "getNote", JSON.stringify(post_data)) //petición
        .then(response => {
          if (response.data.success) {
            self.mtype = response.data.data.medioTipo;
            response.data.data["media"] = response.data.data.claveorigen;
            self.setConfig(response.data.data);
          }else{
            self.$emit('notFound',self.index);
          }
        })
        .catch(function(error) {
          var response = { success: false, error: error };
          console.log(error);
        });
    },
    setConfig(miconfig = null) {
      console.log(miconfig, "mi config");
      this.miconfig = miconfig == null ? this.config : miconfig;

      this.playerOptions.sources[0].src = this.$store.getters.getVideoUrl + this.miconfig.media;
      this.miconfig.thumb = this.miconfig.thumb
        ? this.miconfig.thumb
        : this.miconfig.noticiero.imagen;
      this.playerOptions.poster = this.miconfig.thumb;

      this.defaultImage = this.miconfig.entrada=='T'? this.$store.state.defaultTV: this.$store.state.defaultRadio;
      if (this.miconfig.metadatos) {
        var new_item = this.miconfig.metadatos;
        this.playerOptions.sources[0].src = this.$store.getters.getVideoUrl + this.miconfig.metadatos.claveorigen;
        this.miconfig.titulo = new_item.titulo ? new_item.titulo : this.miconfig.titulo;
        this.miconfig.thumb = new_item.imagen? new_item.imagen:this.miconfig.thumb;
        this.playerOptions.poster = this.miconfig.thumb;
      }
      
      this.itemReady = true;
    },
    playVideo() {
      this.activeVideo = true;
    },
    goToNote() {
      var miconfig = Object.assign(this.config, this.miconfig);
      this.$emit('goToNote',miconfig);
    },
    goToNotes() {
      this.miconfig.key_src = this.miconfig.codigo_noticiero;
      this.$emit("goToNotes", this.miconfig);
    },
   
    parseFecha(fecha) {
      //fecha= "2020-02-06 16:13:12"
      moment.tz.setDefault("America/Mexico_City");
    
      var tmp = moment(fecha);
   
      var f = moment
        .tz(tmp, "America/Mexico_City")
        
        .format("DD/MM/YYYY HH:mm:ss");
        return f;
    },
    // VIDEO PLAYER METHODS
    playerReadied(player) {
      var engine = player.tech_.hls || player.tech_.vhs;
      if (engine && engine.xhr) {
        engine.xhr.beforeRequest = function(options) {
          return options;
        };
      }
    }
  }
};
</script>
<style scoped>
@keyframes blink {
  0% {
        color: rgb(0, 0, 0);
    }
    50% {
        color: #3fe6cd;
    }
    100% {
        color: #00b99e;
    }
}

.blink {
    
    animation: blink 2s infinite;
}
.hora-r {
    /* Estilos para cuando item.entrada es 'R' 
    color: #00b99e;*/
}
</style>
<style>
.linkArrow {
  text-align: right;
  padding: 0px 5px 0px 0px;
  cursor: pointer;
}
.linkArrow:hover{
  color:#00b99e;
}
.touchpad {
  cursor: pointer;
}

.video .video-js {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.video .vjs-poster {
  width: 100%;
  height: auto;
  position: relative;
  border-radius: 15px 15px 0 0 !important;
}

.video-js {
  /*background: transparent!important;*/
  border-radius: 15px 15px 0 0 !important;
}

.vjs-poster {
  width: 100% !important;
  border-radius: 15px 15px 0 0 !important;
}

.card-post-footer {
  text-align: left;
  color: #00b99e;
  font-size: 14px;
  font-family: "Rubik", sans-serif;
  padding: 0 15px 7px;
}

.tvIcon {
  color: #000;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
}

.tvIcon svg {
  width: 20px;
  height: 20px;
}

.video-post .info-video .video-type {
  display: inline-block;
}
</style>